export class ContagemTempoServico {
  dias: number = 0;
  meses: number = 0;
  anos: number = 0;
  totalEmDias: number = 0;
  tipo: string = null;

  constructor(d?) {
    if (d) {
      this.dias = d.dias ? d.dias : 0;
      this.meses = d.meses ? d.meses : 0;
      this.anos = d.anos ? d.anos : 0;
      this.totalEmDias = d.totalEmDias ? d.totalEmDias : 0;
      this.tipo = d.tipo ? d.tipo : null;
    }
  }
}
